import { createSelector } from '@reduxjs/toolkit';

import {
  EvaluationSummaryIssue,
  EvaluationSummaryIssueType,
} from 'src/constants/voicebox';
import { projectSelector } from 'src/selectors/project';

export const projectVoiceboxSummaryIssuesSelector = (projectId: string) =>
  createSelector(projectSelector(projectId), (project) => {
    const evaluation = project?.voiceboxEvaluationSummary;

    const unansweredQuestions: EvaluationSummaryIssue[] = [];
    const unusedResources: EvaluationSummaryIssue[] = [];
    const unlinkedConcepts: EvaluationSummaryIssue[] = [];
    const addQuestions: EvaluationSummaryIssue[] = [];
    const addDataset: EvaluationSummaryIssue[] = [];
    evaluation?.issues.forEach((issue) => {
      switch (issue.type) {
        case EvaluationSummaryIssueType.UNANSWERED_QUESTION:
          unansweredQuestions.push(issue);
          break;
        case EvaluationSummaryIssueType.UNUSED_DATASET:
          unusedResources.push(issue);
          break;
        case EvaluationSummaryIssueType.UNLINKED_CONCEPT:
          unlinkedConcepts.push(issue);
          break;
        case EvaluationSummaryIssueType.ADD_QUESTIONS:
          addQuestions.push(issue);
          break;
        case EvaluationSummaryIssueType.ADD_DATASET:
          addDataset.push(issue);
          break;
        default:
          break;
      }
    });

    return {
      count:
        unansweredQuestions.length +
        unusedResources.length +
        unlinkedConcepts.length +
        addQuestions.length +
        addDataset.length,
      unansweredQuestions,
      unusedResources,
      unlinkedConcepts,
      addQuestions,
      addDataset,
    };
  });
